import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../App';
import { toast } from 'sonner';

const ManagerDashboard = ({ user, onLogout }) => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/orders`, { withCredentials: true });
      // sort by installation date ascending
      const sorted = [...res.data].sort((a, b) => new Date(a.installationDate) - new Date(b.installationDate));
      setOrders(sorted);
    } catch (err) {
      toast.error('Failed to load orders');
    } finally {
      setLoading(false);
    }
  };

  const filtered = orders.filter(o => {
    if (!search) return true;
    const term = search.toLowerCase();
    return (
      o.id.toLowerCase().includes(term) ||
      (o.customer?.name || '').toLowerCase().includes(term) ||
      (o.customer?.email || '').toLowerCase().includes(term) ||
      (o.createdByName || '').toLowerCase().includes(term)
    );
  });

  if (loading) {
    return <div className="loading-screen"><div className="spinner"></div></div>;
  }

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <div>
          <h1 style={{ fontSize: '28px', fontWeight: 800 }}>Manager Dashboard</h1>
          <div style={{ color: '#555', marginTop: '4px' }}>Company: {user.company || 'N/A'}</div>
        </div>
        <button className="btn btn-secondary" onClick={onLogout}>Logout</button>
      </div>

      <div style={{ marginBottom: '16px' }}>
        <input
          type="text"
          className="form-input"
          placeholder="Search by order id, customer, email, sales person"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ maxWidth: '420px' }}
        />
      </div>

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Customer</th>
              <th>Installation Date</th>
              <th>Store Invoice #</th>
              <th>Status</th>
              <th>Sales Person</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(order => (
              <tr key={order.id}>
                <td style={{ fontFamily: 'monospace', fontSize: '13px' }}>{order.id.substring(0,8)}</td>
                <td>{order.customer?.name}</td>
                <td>{order.installationDate}</td>
                <td>{order.storeInvoiceNumber || '-'}</td>
                <td><span className={`badge badge-${order.status}`}>{order.status.replace('_',' ')}</span></td>
                <td>{order.createdByName}</td>
                <td style={{ fontWeight: 600 }}>${order.totals?.total}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {filtered.length === 0 && (
          <div style={{ textAlign:'center', padding:'40px', color:'#888' }}>No orders found.</div>
        )}
      </div>
    </div>
  );
};

export default ManagerDashboard;
